
import { defineComponent, PropType } from 'vue';
import Button from '@/models/ButtonModel';
import Message from '@/models/MessageModel';

export default defineComponent({
	name: 'SelectChanelButton',
	props: {
		displayType: {
			type: String,
			required: true
		},
		button: {
			type: Object as PropType<Button>,
			required: true
		},
		disabled: {
			type: Boolean
		},
		message: {
			type: Object as PropType<Message>
		},
		showText: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		// Нужно чтобы корректно отобразить цвет для веба,
		// через переменную scss как с остальными соц сетями не получилсь
		// так как там не подхватывается на лету переменная "primary"
		getBrandColor(): string {
			const provider = this.button.params.provider;
			console.log(provider);
			if (!provider || provider === 'web') {
				return 'primary';
			}
			return provider;
		},
		// Получение иконок для кнопок
		getMessengerIconLink(): string {
			switch (this.button.params.provider) {
				case 'telegram':
					return 'img:/img/icons/telegram_white_icon.png';
				case 'facebook':
					return 'img:/img/icons/fb_massenger_gradient_icon.png';
				case 'vkontakte':
					return 'img:/img/icons/vk_white_icon.png';
				case 'whatsapp':
					return 'img:/img/icons/icon_whatsUp.png';
				case 'max':
					return 'img:/img/icons/max.svg';
				case 'web':
					return 'public';
				default:
					return '';
			}
		}
	},
	emits: ['click']
});
